/**
 * DEPRECATED: This file is being phased out.
 * All colors should come from design-tokens.css via CSS variables.
 *
 * For inline styles, use: style={{ color: 'var(--color-primary-500)' }}
 * For Tailwind classes, use: className="bg-primary-500 text-neutral-900"
 * For CSS modules, use: var(--color-primary-500)
 *
 * These exports use CSS variable references so they stay in sync
 * with design-tokens.css (the single source of truth).
 */

// @deprecated - Use Tailwind classes (bg-primary-500) or CSS var(--color-primary-500) instead
export const bgColors = {
  primary_bg: 'var(--color-primary-500)',
  secondary_bg: 'var(--color-neutral-900)',
  tertiary_bg: 'var(--color-neutral-0)',
  grey: 'var(--color-neutral-200)',
  disabled: 'var(--color-neutral-400)',
  enabled: 'var(--color-neutral-50)',
  primary50: 'var(--color-primary-50)',
  primary100: 'var(--color-primary-100)',
  primary200: 'var(--color-primary-200)',
  primary400: 'var(--color-primary-400)',
  progressbar_bg: 'var(--color-neutral-100)',
};
export const textColors = {
  primary: 'var(--color-primary-500)',
  secondary: 'var(--color-neutral-900)',
  secondary500: 'var(--color-neutral-400)',
  secondary600: 'var(--color-neutral-600)',
  tertiary: 'var(--color-neutral-0)',
  neutral: 'var(--color-neutral-600)',
  gray: 'var(--color-neutral-500)',
  black: 'var(--color-neutral-1000)',
  error: 'var(--color-error)',
  blueGray: 'var(--color-neutral-700)',
};
export const borderColors = {
  primary: 'var(--color-neutral-200)',
  primary500: 'var(--color-primary-500)',
  secondary: 'var(--color-primary-600)',
  errorColor: 'var(--color-error)',
  grey: 'var(--color-neutral-200)',
};
export const toastColor = {
  success: 'var(--color-success)',
  error: 'var(--color-error)',
  promise: 'var(--color-info)',
};

// Profile avatar background colors - kept as these are specific to avatar rendering
export const profileBgMapping = [
  '#fff0f7',
  '#d9fbfb',
  '#f7f3f2',
  '#f6f2ff',
  '#e5f6ff',
  '#defbe6',
  '#f2f4f8',
  '#edf5ff',
  '#f4f4f4',
  '#fff1f1',
];

// @deprecated - These Tailwind plugin utilities should migrate to design-tokens.css utility classes
export const colorConfigs = {
  '.primary-bg': {
    background: 'var(--color-primary-500)',
  },
  '.secondary-bg': {
    background: 'var(--color-neutral-900)',
  },
  '.tertiary-bg': {
    background: 'var(--color-neutral-0)',
  },
  '.bg-grey': {
    background: 'var(--color-neutral-200)',
  },
  '.disabled-bg': {
    background: 'var(--color-neutral-400)',
  },
  '.enabled-bg': {
    background: 'var(--color-neutral-50)',
  },
  '.primary50-bg': {
    background: 'var(--color-primary-50)',
  },
  '.primary100-bg': {
    background: 'var(--color-primary-100)',
  },
  '.primary200-bg': {
    background: 'var(--color-primary-200)',
  },
  '.primary400-bg': {
    background: 'var(--color-primary-400)',
  },
  '.text-secondary': {
    color: 'var(--color-neutral-900)',
  },
  '.text-secondary500': {
    color: 'var(--color-neutral-400)',
  },
  '.text-secondary600': {
    color: 'var(--color-neutral-600)',
  },
  '.text-primary': {
    color: 'var(--color-primary-500)',
  },
  '.text-tertiary': {
    color: 'var(--color-neutral-0)',
  },
  '.text-black': {
    color: 'var(--color-neutral-1000)',
  },
  '.text-error': {
    color: 'var(--color-error)',
  },
  '.text-gray': {
    color: 'var(--color-neutral-500)',
  },
  '.text-bluegray': {
    color: 'var(--color-neutral-700)',
  },
  '.text-neutral': {
    color: 'var(--color-neutral-600)',
  },
  '.border-primary': {
    borderColor: 'var(--color-neutral-200)',
  },
  '.border-primary500': {
    borderColor: 'var(--color-primary-500)',
  },
  '.border-secondary': {
    borderColor: 'var(--color-primary-600)',
  },
  '.border-error': {
    borderColor: 'var(--color-error)',
  },
  '.progressbar-bg': {
    background: 'var(--color-neutral-100)',
  },
  '.primary-accent': {
    accentColor: 'var(--color-primary-500)',
  },
  '.loader-gradient': {
    background: 'linear-gradient(90deg, var(--color-primary-50) 0%, #ffd0ff 121.67%)',
  },
};

// @deprecated - Use CSS module button styles or Tailwind classes instead
export const buttonConfigs = {
  '.btn-primary': {
    background: 'var(--color-primary-500)',
    padding: '11px 30px 11px 30px',
  },
};
